import React from 'react';
import { Typography, Box, Paper, Button } from '@mui/material';
import { QrCodeScanner, CameraAlt } from '@mui/icons-material';
import Layout from '../components/Layout';

const QRScanner: React.FC = () => {
  return (
    <Layout>
      <Box>
        <Typography variant="h4" gutterBottom>
          Escáner de Códigos QR
        </Typography>
        
        <Paper sx={{ p: 3, mt: 2, textAlign: 'center' }}>
          <QrCodeScanner sx={{ fontSize: 80, color: 'primary.main', mb: 2 }} />
          
          <Typography variant="h6" gutterBottom>
            Escáner QR - En Desarrollo
          </Typography>
          
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Esta función permitirá escanear códigos QR de cupones para validar y procesar redenciones en tiempo real.
          </Typography>

          <Box sx={{ mb: 3 }}>
            <Typography variant="body2" color="text.secondary">
              Funcionalidades incluidas:
            </Typography>
            <Box component="ul" sx={{ mt: 1, textAlign: 'left', display: 'inline-block' }}>
              <li>Escáner de cámara en tiempo real</li>
              <li>Validación automática de códigos QR</li>
              <li>Mostrar detalles del cupón y cliente</li>
              <li>Botones para aprobar/rechazar</li>
              <li>Verificación de vigencia y usos</li>
              <li>Histórico de escaneos</li>
            </Box>
          </Box>

          <Button
            variant="contained"
            startIcon={<CameraAlt />}
            disabled
            sx={{ mt: 2 }}
          >
            Activar Cámara (Próximamente)
          </Button>
        </Paper>

        <Paper sx={{ p: 3, mt: 2 }}>
          <Typography variant="h6" gutterBottom>
            Instrucciones de Uso
          </Typography>
          <Box component="ol" sx={{ pl: 2 }}>
            <li>Haz clic en "Activar Cámara" para iniciar el escáner</li>
            <li>Apunta la cámara hacia el código QR del cupón</li>
            <li>El sistema validará automáticamente el código</li>
            <li>Revisa los detalles del cupón y cliente mostrados</li>
            <li>Selecciona "Aprobar" o "Rechazar" según corresponda</li>
            <li>El cupón se marcará como usado si es aprobado</li>
          </Box>
        </Paper>
      </Box>
    </Layout>
  );
};

export default QRScanner;
